import { Typography as e } from "../../Typography/Typography.mjs";
import { Button as t } from "../Button/Button.mjs";
import { PageIllustration as n } from "../Illustration/PageIllustration.mjs";
import { CopyBlock as r, PageActionSlot as i, PageBodySlot as a, PageContainer as o, PageTitleSlot as s } from "./PageEmptyState.styled.mjs";
import c from "react";
import { useTranslation as l } from "@maat/store-i18n";
import { jsx as u, jsxs as d } from "react/jsx-runtime";
import { ILL_PAGE_SCENES as f, ILL_PAGE_TEXT as p } from "@maat/assets";
//#region src/components/EmptyState/PageEmptyState.tsx
var m = ({ name: m, title: h, body: g, action: _, onAction: v, align: y = "center", artWidth: b, playKey: x, motion: S = !0, children: C, className: w }) => {
	let { t: T } = l("ds"), [E, D] = c.useState(S);
	c.useEffect(() => {
		if (!S) {
			D(!1);
			return;
		}
		D(!0);
		let e = setTimeout(() => D(!1), f[m].dur);
		return () => clearTimeout(e);
	}, [
		x,
		m,
		S
	]);
	let O = h ?? T(`emptyPage.${m}.title`), k = g === void 0 ? T(`emptyPage.${m}.body`, "") : g;
	return /* @__PURE__ */ d(o, {
		className: w,
		$align: y,
		children: [/* @__PURE__ */ u(n, {
			name: m,
			width: b,
			playKey: x,
			motion: S
		}), /* @__PURE__ */ d(r, {
			$align: y,
			className: E ? "pl" : void 0,
			children: [
				/* @__PURE__ */ u(s, {
					style: { animationDelay: `${p.at[0]}ms` },
					children: /* @__PURE__ */ u(e, {
						variant: "h3",
						align: y,
						children: O
					})
				}),
				k ? /* @__PURE__ */ u(a, {
					style: { animationDelay: `${p.at[1]}ms` },
					children: /* @__PURE__ */ u(e, {
						variant: "body",
						color: "secondary",
						align: y,
						children: k
					})
				}) : null,
				_ && v || C ? /* @__PURE__ */ d(i, {
					$align: y,
					style: { animationDelay: `${p.at[2]}ms` },
					children: [_ && v ? /* @__PURE__ */ u(t, {
						onClick: v,
						children: _
					}) : null, C]
				}) : null
			]
		})]
	});
};
//#endregion
export { m as PageEmptyState };
